// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"87212a06","58":"12f5d338","77":"9fa96250","96":"97b45923","104":"10c5413e","217":"f33eb4aa","329":"50ed1fdf","479":"efb82ed1","490":"f6b72646","522":"b4678470","570":"fafa6359","693":"44cf193d","718":"5b577e9c","744":"3fb50e6c","764":"03ba8922","910":"27eb719d"}[chunkId] + ".chunk.js";
};